export default {
  accepted: {
    title: '签名已确认',
    description: '签名已确认。感谢您使用我们的配送服务！',
  },
  info: '您有一份来自',
  title: '请核实您的信息：',
  fields: {
    name: '收件人姓名：',
    phone: '收件人电话：',
    address: '收件人地址：',
    'rx-number': '处方编号：',
  },
  'action-btn': '提交',
  'empty-signature': '请在提交前绘制您的签名。',
}
